module.exports = __webpack_public_path__ + "media/images/users/avatar-8-e72b3dc7d03c5502731f46a66171cfad.jpg";